import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.eLabel.fields.id'),
  },
  {
    name: 'photos',
    label: i18n('entities.eLabel.fields.photos'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'porductTitle',
    label: i18n('entities.eLabel.fields.porductTitle'),
  },
  {
    name: 'productSubtitle',
    label: i18n('entities.eLabel.fields.productSubtitle'),
  },
  {
    name: 'productDescription',
    label: i18n('entities.eLabel.fields.productDescription'),
  },
  {
    name: 'productType',
    label: i18n('entities.eLabel.fields.productType'),
  },
  {
    name: 'productVolume',
    label: i18n('entities.eLabel.fields.productVolume'),
  },
  {
    name: 'producer',
    label: i18n('entities.eLabel.fields.producer'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'ingredients',
    label: i18n('entities.eLabel.fields.ingredients'),
  },
  {
    name: 'nutritionInformation',
    label: i18n('entities.eLabel.fields.nutritionInformation'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'sustainability',
    label: i18n('entities.eLabel.fields.sustainability'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'packagingCertification',
    label: i18n('entities.eLabel.fields.packagingCertification'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'recyclingMaterials',
    label: i18n('entities.eLabel.fields.recyclingMaterials'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'foodOperator',
    label: i18n('entities.eLabel.fields.foodOperator'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'productEan',
    label: i18n('entities.eLabel.fields.productEan'),
  },
  {
    name: 'responsibleConsumption',
    label: i18n('entities.eLabel.fields.responsibleConsumption'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'language',
    label: i18n('entities.eLabel.fields.language'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.eLabel.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.eLabel.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
